<script>
  import gql from 'graphql-tag'

  export default {
    props: ['gid'],
    apollo: {
      settings: {
        fetchPolicy: "no-cache",
        query: gql`query($gid: ID) {
          merchant(gid: $gid) { merchantUser { settings { pay {
            ppdRefundTerminal { maxAmountCents delayDays }
          }}}}
        }`,
        variables() {
          return { gid: this.gid }
        },
        update: data => data.merchant.merchantUser.settings.pay
      }
    },
    data() {
      return {
        settings: {},
        showForm: false,
        form: { maxAmountCents: null, delayDays: null }
      }
    },
    computed: {
      maxAmountCents() {
        return this.settings.ppdRefundTerminal && this.settings.ppdRefundTerminal.maxAmountCents
      },
      delayDays() {
        return this.settings.ppdRefundTerminal && this.settings.ppdRefundTerminal.delayDays
      }
    },
    methods: {
      openEdit() {
        const t = this.settings.ppdRefundTerminal || {}
        this.form.maxAmountCents = t.maxAmountCents
        this.form.delayDays = t.delayDays
        this.showForm = true
        this.$nextTick(() => M.updateTextFields())
      },
      save() {
        this.$apollo.mutate({
          mutation: gql`mutation (
            $gid: ID!,
            $maxAmountCents: Int,
            $delayDays: Int
          ) {
            updatePpdRefundTerminalPreferences(input: {
              userId: $gid,
              maxAmountCents: $maxAmountCents,
              delayDays: $delayDays
            }) {
              ppdRefundTerminal { maxAmountCents delayDays }
              errors
            }
          }`,
          variables: {
            gid: this.gid,
            maxAmountCents: this.form.maxAmountCents === '' ? null : this.form.maxAmountCents,
            delayDays: this.form.delayDays === '' ? null : this.form.delayDays
          }
        }).then(result => {
          const payload = result.data.updatePpdRefundTerminalPreferences
          if (payload.errors && payload.errors.length) {
            this.notifyError(payload.errors.join(', '))
            return
          }
          this.settings = { ...this.settings, ppdRefundTerminal: payload.ppdRefundTerminal }
          this.showForm = false
          this.notifySuccess("Refund preferences updated")
        }, error => {
          this.gqlErrorHandler(error)
        })
      }
    }
  }
</script>

<template>
  <div v-if="!$apollo.queries.settings.loading">
    <div class="very-close-lines">
      Check refund limits:<br>
      <small class="grey-text">Max refund amount and minimum delay before refundable</small>
    </div>

    <div v-if="settings.ppdRefundTerminal" class="mt-5 grey-text">
      Max:
      <template v-if="maxAmountCents != null">{{ maxAmountCents }} cents ({{ maxAmountCents / 100 | currency }})</template>
      <template v-else>no cap</template>
      · Delay:
      <template v-if="delayDays != null">{{ delayDays }} day(s)</template>
      <template v-else>—</template>
      |
      <a class="pointer" @click="openEdit"><i class="far fa-edit"></i> Edit</a>
    </div>

    <div v-else class="mt-5 grey-text">
      Merchant has no PPD refund terminal
    </div>

    <div class="row mb-0 mt-10" v-show="showForm">
      <div class="input-field col s6">
        <input id="ppd_max_amount_cents" type="number" min="0" v-model.number="form.maxAmountCents">
        <label for="ppd_max_amount_cents" class="active">Max amount (cents)</label>
        <span class="helper-text grey-text">
          <template v-if="form.maxAmountCents != null && form.maxAmountCents !== ''">
            {{ form.maxAmountCents / 100 | currency }}
          </template>
          <template v-else>no cap</template>
        </span>
      </div>
      <div class="input-field col s6">
        <input id="ppd_delay_days" type="number" min="0" v-model.number="form.delayDays">
        <label for="ppd_delay_days" class="active">Delay (days)</label>
      </div>
      <div class="col s12">
        <button class="btn-small emerald" @click="save" :disabled="$apollo.loading">Save</button>
        <a class="pointer ml-10 grey-text" @click="showForm = false">Cancel</a>
      </div>
    </div>
  </div>
</template>
